<nav class="_bg-white sm-max:_shadow-bottom">
    <div>
        <img *ngIf="logoUrl" [src]="logoUrl" class="_max-h-9" alt="company logo" />
        <img *ngIf="!logoUrl" app-logo class="_h-4"/>
    </div>

    <div class="menu-items-container">
        <div class="currency-select-container _cursor-pointer">
            <app-currency-select></app-currency-select>
        </div>
    </div>
</nav>
